module.exports = __webpack_public_path__ + "static/img/link.d654690.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link.png
// module id = 6tLM
// module chunks = 1